import { I18n as OriginalI18n } from 'i18n-js'
import translations from './i18n.current.json'
// ^ auto-generated file, DO NOT EDIT, run `script/set_translations` instead

const i18n = new OriginalI18n(translations)

const backendLocale = document.documentElement.lang

// i18n-js falls back to less specific locales automatically, e.g. from de-AT to de
i18n.locale = /^de/.test(backendLocale) ? backendLocale : 'en'
i18n.enableFallback = true
i18n.defaultLocale = 'de' // TODO: en
i18n.missingTranslation.register('report', (_, key) => {
  const error = `missing translation in frontend: "${key}"`
  console.error(error)
  return ''
})
i18n.missingBehavior = 'report'

// support camelized key names and interpolation args, snake-case them
i18n.transformKey = (k) => k.replace(/([a-z])([A-Z])/g, (_m, c1, c2) => `${c1}_${c2.toLowerCase()}`)

export const I18n = i18n
export const t = i18n.t.bind(i18n)
